<template>
    <div class="item" :class="columns===1?'long':null" @click="onPressNav('articleDetail', {id: item.id})">
        <img :src="item.cover" v-if="item.cover" />
        <div>
            <p class="title">{{item.name}}</p>
            <p class="text">{{item.overview}}</p>
        </div>
    </div>
</template>
<script>
export default {
    name: "reviewItem",
    props:['item',"columns"],
    methods: {
        onPressNav(router, query={}) {
            this.$router.push({path: '/'+router, query: query})
        },
    }
};
</script>
<style lang="less" scoped>
.item {
    overflow: hidden;
    margin-top: 1.5rem;
    background: #ffffff;
    border-radius: .5rem;
    width: calc(50% - 5px);
    box-shadow: 0px 0px 5px 0px rgba(51,51,51,0.10); 

    > img {
        width: 100%;
        height: 15rem;
        display: block;
        margin: 0 0 0px;
        object-fit: cover;
    }

    div {
        padding:10px;
        .title {
            margin-bottom: 8px;
            font-size: 15px;
            line-height: 1.5;
            color: #333;
            font-weight: 500;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
        }

        .text {
            color: #666;
            font-size: 12px;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
        }
    }
}
.long {
    width: 100%;
}
</style>